import { context } from '@wikia/ad-engine';

export function getIndexExchangeContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.adhesion_limited ?? [
						[300, 50],
						[320, 50],
					],
					siteId: '1123789',
				},
			}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[300, 50],
						[320, 50],
						[320, 100],
					],
					siteId: '419027',
				},
			};

	return {
		enabled: false,
		slots: {
			mobile_top_leaderboard: {
				sizes: [[320, 50]],
				siteId: '183568',
			},
			mobile_in_content: {
				sizes: [[300, 250]],
				siteId: '185055',
			},
			bottom_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.bottom_leaderboard ?? [
					[300, 250],
					[320, 50],
				],
				siteId: '185056',
			},
			...floorAdhesionConfigs,
			interstitial: {
				sizes: [[320, 480]],
				siteId: '749519',
			},
			gallery_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.gallery_leaderboard ?? [
					[320, 100],
					[320, 50],
				],
				siteId: ['1019180'],
			},
			featured: {
				siteId: '437503',
			},
		},
	};
}
